import { CommonModule } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { FormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '@core/services/userHandler/user.service';
import { LoginComponent } from '../../../login/components/login/login.component';
import { PurchaseFeesComponent } from '../purchase-fees/purchase-fees.component';
import { SpinnerComponent } from '../spinner/spinner.component';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'cgw-dialog-modal',
  templateUrl: './dialog-modal.component.html',
  styleUrls: ['./dialog-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoginComponent,
    PurchaseFeesComponent,
    SpinnerComponent,
    MaterialModule,
  ],
})
export class DialogModalComponent implements OnInit {
  legals: UntypedFormGroup;
  confirmNo: boolean = false;
  fees: boolean = false;
  promoGame: boolean = false;
  confirmNoMsg: boolean = false;
  confirmSend: boolean = false;
  closeGestion: boolean = false;
  deleteQuestion: boolean = false;
  login: boolean = false;
  sendPass: boolean = false;
  userExist: boolean = false;
  changePass: boolean = false;
  comment: string;
  legales: any;
  loading: boolean = false;
  loadingBloq: boolean = false;
  userRegister: boolean = false;
  validarMail: boolean = false;
  dobleReserva: boolean = false;
  errorCompra: boolean = false;
  errorCompraEtiqueta: boolean = false;
  errorDomicilio: boolean = false;
  errorMedioEnvio: boolean = false;
  dobleMail: boolean = false;
  cuentaMismoDoc: boolean = false;
  noArmadoService: boolean = false;
  informacion: boolean = false;
  verificacion: boolean = false;
  verificacionPaso: string;
  confirmacion_logout: boolean = false;
  borrarCarrito: boolean = false;
  billing_out: boolean = false;
  errorNoCuil: boolean = false;
  errorNoDni: boolean = false;
  errorTokenTarjeta: boolean = false;
  errorProcessPayment: boolean = false;
  successProcessPayment: boolean = false;
  precioEspecial: boolean = false;
  url: string = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public type: any,
    public dialogRef: MatDialogRef<DialogModalComponent>,
    private fb: UntypedFormBuilder,
    private userService: UserService,
  ) {}

  ngOnInit(): void {
    this.url = new URL(window.location.href).origin;
    this.legals = this.fb.group({
      tardanza: [false],
      documentacion: ['', Validators.required],
    });
    console.log(this.type);
    switch (this.type.type) {
      case 'confirmNo':
        this.confirmNo = true;
        break;
      case 'fees':
        this.fees = true;
        break;
      case 'promoGame':
        this.promoGame = true;
        break;

      case 'confirm':
        this.confirmSend = true;
        break;
      case 'confirmNoMsg':
        this.confirmNoMsg = true;
        break;
      case 'closeGestion':
        this.closeGestion = true;
        break;
      case 'deleteQuestion':
        this.deleteQuestion = true;
        break;
      case 'login':
        this.login = true;
        break;
      case 'sendPass':
        this.sendPass = true;
        break;
      case 'userExist':
        this.userExist = true;
        break;
      case 'userRegister':
        this.userRegister = true;
        break;
      case 'changePass':
        this.changePass = true;
      case 'loading':
        this.loading = true;
        break;
      case 'validarMail':
        this.validarMail = true;
        break;
      case 'errorCompra':
        this.errorCompra = true;
        break;
      case 'errorCompraEtiqueta':
        this.errorCompraEtiqueta = true;
        break;
      case 'dobleReserva':
        this.dobleReserva = true;
        break;
      case 'errorDomicilio':
        this.errorDomicilio = true;
        break;
      case 'loadingBloq':
        this.loadingBloq = true;
        break;
      case 'errorMedioEnvio':
        this.errorMedioEnvio = true;
        break;
      case 'dobleMail':
        this.dobleMail = true;
        break;
      case 'cuentaMismoDoc':
        this.cuentaMismoDoc = true;
        break;
      case 'informacion':
        this.informacion = true;
        break;
      case 'verificacion':
        this.verificacion = true;
        this.verificacionPaso = this.type.paso;
        break;
      case 'noArmadoService':
        this.noArmadoService = true;
        break;
      case 'confirmacion_logout':
        this.confirmacion_logout = true;
        break;
      case 'borrarCarrito':
        this.borrarCarrito = true;
        break;
      case 'billing_out':
        this.billing_out = true;
        break;
      case 'errorNoCuil':
        this.errorNoCuil = true;
        break;
      case 'errorNoDni':
        this.errorNoDni = true;
        break;
      case 'errorProcessPayment':
        this.errorProcessPayment = true;
        break;
      case 'errorTokenTarjeta':
        this.errorTokenTarjeta = true;
        break;
      case 'successProcessPayment':
        this.successProcessPayment = true;
        break;
      case 'precioEspecial':
        this.precioEspecial = true;
      default:
        break;
    }
    this.legals.statusChanges.subscribe((status) => {
      console.log(status, this.legals);
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  returnClose(value) {
    console.log(value);
    if (value == true) {
      this.onNoClick();
    }
  }

  sendMailAgain() {
    const data = {
      id: UserService.getUser(),
    };
    this.userService.validarMail(data).subscribe((res) => {
      console.log(res);
      this.onNoClick();
    });
  }
}
